import * as actionTypes from './actionTypes';
import axios from '../../axios-url';

export const keywordListStart = () => {
    return {
        type: actionTypes.KEYWORD_LIST_START
    }
}

export const keywordListSuccess = (keyword, lists) => {
    return {
        type: actionTypes.KEYWORD_LIST_SUCCESS,
        lists: lists,
        keyword: keyword,
    }
}

export const keywordListFail = (error) => {
    return {
        type: actionTypes.KEYWORD_LIST_FAIL,
        error: error
    }
}

// export const getMasterKeywordList = (keyword) =>{
//     return dispatch => {
//         dispatch(keywordListStart());
//             const masterTableList = !['JobRequisition', 'JobApplication'].includes(keyword) ? localStorage.getItem('DropDownValues-'+keyword) : false;
//             if(!masterTableList){
//                 axios.get('/master/api/DropDownValues/'+keyword)
//                 .then(response =>{
//                     if(response.status === 200){
//                         let data = [];
//                         if(response.data && response.data.length > 0){
//                             data = response.data.map(list => {
//                                 let value= list.id;
//                                 let id = list.id;
//                                 let text = list.text
//                                 if(list.type === 'TimeoffType' || list.type === 'ApprovalType' || list.type === 'employee' || list.type === 'OrgUnit' || list.type ==='position' || list.type === 'TimeOffPolicy' || list.type === 'Job' || list.type==='EmployeeGroup' || list.type==='Department' || list.type==='Division' || list.type==='Section' || list.type==='UnCategorized' || list.type==='VicePresident'  || list.type==='Executive' || list.type === 'JobRequisition' || list.type === 'JobApplication' || list.type === 'ExpenseType' || list.type === 'HDSQueue' || list.type === 'HDSQueueRep'  || list.type === 'HDSCategory'   || list.type === 'HDSSubCategory'    || list.type === 'Asset'  || list.type === 'sla'  || list.type === 'ITSMIncident'  || list.type === 'ITSMProblem'  || list.type === 'ITSMCabMembers' || list.type === 'Customer' || list.type === 'Service' || list.type === 'UOM'  || list.type === 'ExpenseType' || list.type === 'AdvanceType' || list.type === 'Vendor'){
//                                     value= list.uniqueId;
//                                 }

//                                 if(list.type === 'JobRequisition' || list.type === 'JobApplication'){
//                                     text = list.requestNum
//                                 }
//                                 if(list.type === 'HDSSubCategory' || list.type === 'HDSCategory')
//                                 {
//                                     id = list.requestNum
//                                 }
//                                 return {label : text, value:value.toString(), id:id};
//                             })
//                         }
//                         localStorage.setItem('DropDownValues-'+keyword,JSON.stringify(data));
//                         dispatch(keywordListSuccess(keyword,data));                    
//                     }
//                 })
//                 .catch(err => {
//                     dispatch(keywordListFail(err && err.response && err.response.data || 'Keyword List Api Error'));
//                 })    
//             }
//             else{
//                 dispatch(keywordListSuccess(keyword,JSON.parse(masterTableList)));
//             }
//     }
// }
export const getMasterKeywordList = (keyword) => {
    return dispatch => {
        dispatch(keywordListStart());
        let masterTableList = !['JobRequisition', 'JobApplication', 'position'].includes(keyword) ? localStorage.getItem('DropDownValues-' + keyword) : false;
        // MenuComponent options used to be cached with the numeric id as their value; the value must be the
        // uniqueId GUID. Discard a cache written before that fix so it self-heals.
        if (masterTableList && keyword === 'MenuComponent') {
            try {
                const cached = JSON.parse(masterTableList);
                if (Array.isArray(cached) && cached.some(item => item && /^\d+$/.test(String(item.value)))) {
                    localStorage.removeItem('DropDownValues-MenuComponent');
                    masterTableList = false;
                }
            } catch (e) {
                localStorage.removeItem('DropDownValues-MenuComponent');
                masterTableList = false;
            }
        }
        // Ingredient's cached shape changed (id used to be the numeric master row id; it must be requestNum,
        // e.g. "ING001"). Detect and discard a cache written before that fix so it self-heals without requiring
        // a manual localStorage clear, instead of silently matching against the stale numeric id forever.
        if (masterTableList && keyword === 'Ingredient') {
            try {
                const cached = JSON.parse(masterTableList);
                const isStale = Array.isArray(cached) && cached.some(item => item && item.id !== undefined && item.id !== null && /^\d+$/.test(String(item.id)));
                if (isStale) {
                    localStorage.removeItem('DropDownValues-Ingredient');
                    masterTableList = false;
                }
            } catch (e) {
                localStorage.removeItem('DropDownValues-Ingredient');
                masterTableList = false;
            }
        }
        if (!masterTableList) {
            if (keyword.includes(',')) {
                axios.get('/master/api/dropdowntypeselected?condition=' + keyword)
                    .then(response => {
                        if (response.status === 200) {
                            console.log('response.data', response);
                            const grouped = {};
                            if (response.data && response.data.length > 0) {
                                response.data.forEach(list => {
                                    let value = list.id;
                                    let id = list.id;
                                    let text = list.text
                                    if (  list.type === 'Printer' || list.type === "PR" || list.type === "RFQ" || list.type === "TenantZone" || list.type === "PropertyGroup" || list.type === "Country" || list.type === "ServiceGroup" || list.type === "StorageLocation" || list.type === 'Kitchen' || list.type === 'Modifier' ||  list.type === "Branch" || list.type === 'TimeoffType' || list.type === 'ApprovalType' || list.type === 'employee' || list.type === 'OrgUnit' || list.type === 'position' || list.type === 'TimeOffPolicy' || list.type === 'Job' || list.type === 'EmployeeGroup' || list.type === 'Department' || list.type === 'Division' || list.type === 'Section' || list.type === 'UnCategorized' || list.type === 'VicePresident' || list.type === 'Executive' || list.type === 'JobRequisition' || list.type === 'JobApplication' || list.type === 'ExpenseType' || list.type === 'HDSQueue' || list.type === 'HDSRequestType' || list.type === 'HDSQueueRep' || list.type === 'HDSCategory' || list.type === 'HDSSubCategory' || list.type === 'Asset' || list.type === 'sla' || list.type === 'ITSMIncident' || list.type === 'ITSMProblem' || list.type === 'ITSMCabMembers' || list.type === 'Customer' || list.type === 'Service' || list.type === 'UOM' || list.type === 'ExpenseType' || list.type === 'AdvanceType' || list.type === 'Vendor' || list.type === 'Project' || list.type === 'CostCenter' || list.type === 'EmployeeGroup' || list.type === 'Allowance' || list.type === "UOM" || list.type === "MenuItem" || list.type === "MenuComponent" || list.type === "Ingredient" || list.type === "KitchenSection" || list.type === "MenuCategory"  || list.type === "location" || list.type==="Accounts" || list.type === "Waiter" || list.type==="OrderType" || list.type==="Ingcategory" || list.type === "resRolesandResponsibility" ||list.type === 'resMealPeriod') {
                                        value = list.uniqueId;
                                    }
                                    if (list.type === 'JobRequisition' || list.type === 'JobApplication') {
                                        text = list.requestNum
                                    }
                                    if (list.type === 'PR' || list.type === 'RFQ') {
                                        text = `${list.requestNum}-${list.text}`
                                    }
                                    if (list.type === 'HDSSubCategory' || list.type === 'HDSCategory' || list.type === 'Vendor' || list.type === 'ShiftPattern' || list.type === 'Project' || list.type === 'CostCenter' || list.type === 'Ingredient') {
                                        id = list.requestNum
                                    }
                                    if (list.type === 'ShiftPattern' ) {
                                        value = list.requestNum
                                    }
                                    const mapped = { label: text, value: value.toString(), id: id };
                                    const typeKey = list.type;
                                    if (!grouped[typeKey]) grouped[typeKey] = [];
                                    grouped[typeKey].push(mapped);
                                })
                            }
                            // dispatch each keyword's slice separately so state.keyword[<Vendor|Currency|...>] populates individually
                            Object.keys(grouped).forEach(typeKey => {
                                localStorage.setItem('DropDownValues-' + typeKey, JSON.stringify(grouped[typeKey]));
                                console.log('DISPATCHING keywordListSuccess:', typeKey, grouped[typeKey]);
                                dispatch(keywordListSuccess(typeKey, grouped[typeKey]));
                            });
                        }
                    })
                    .catch(err => {
                        dispatch(keywordListFail(err && err.response && err.response.data || 'Keyword List Api Error'));
                    })
            }
            // OLD working Fine 
            else {
                axios.get('/master/api/DropDownValues/' + keyword)
                    .then(response => {
                        if (response.status === 200) {
                            let data = [];
                            if (response.data && response.data.length > 0) {
                                data = response.data.map(list => {
                                    let value = list.id;
                                    let id = list.id;
                                    let text = list.text
                                    if ( list.type === 'Printer' || list.type === "PR" || list.type === "RFQ" || list.type === "TenantZone" || list.type === "PropertyGroup" || list.type === "Country" || list.type === "ServiceGroup" || list.type === "StorageLocation"|| list.type === 'Kitchen' || list.type === 'Modifier' || list.type === 'Branch' || list.type === 'MenuCategory' ||list.type === 'TimeoffType' || list.type === 'ApprovalType' || list.type === 'employee' || list.type === 'OrgUnit' || list.type === 'position' || list.type === 'TimeOffPolicy' || list.type === 'Job' || list.type === 'EmployeeGroup' || list.type === 'Department' || list.type === 'Division' || list.type === 'Section' || list.type === 'UnCategorized' || list.type === 'VicePresident' || list.type === 'Executive' || list.type === 'JobRequisition' || list.type === 'JobApplication' || list.type === 'ExpenseType' || list.type === 'HDSQueue' || list.type === 'HDSRequestType' || list.type === 'HDSQueueRep' || list.type === 'HDSCategory' || list.type === 'HDSSubCategory' || list.type === 'Asset' || list.type === 'sla' || list.type === 'ITSMIncident' || list.type === 'ITSMProblem' || list.type === 'ITSMCabMembers' || list.type === 'Customer' || list.type === 'Service' || list.type === 'UOM' || list.type === 'ExpenseType' || list.type === 'AdvanceType' || list.type === 'Vendor' || list.type === 'Project' || list.type === 'CostCenter' || list.type === 'EmployeeGroup' || list.type === 'Allowance' || list.type === "UOM" || list.type === "MenuItem" || list.type === "MenuComponent" || list.type === "Ingredient" || list.type === "KitchenSection" || list.type === "location"|| list.type==="Accounts" || list.type === "Waiter" || list.type==="OrderType" || list.type==="Ingcategory" || list.type === "resRolesandResponsibility" ||list.type === 'resMealPeriod' ) {
                                        value = list.uniqueId;
                                    }

                                    if (list.type === 'JobRequisition' || list.type === 'JobApplication') {
                                        text = list.requestNum
                                    }
                                    if (list.type === 'PR' || list.type === 'RFQ') {
                                        text = `${list.requestNum}-${list.text}`
                                    }
                                    if (list.type === 'HDSSubCategory' || list.type === 'HDSCategory' || list.type === 'Vendor' || list.type === 'ShiftPattern' || list.type === 'Project' || list.type === 'CostCenter' || list.type === 'Ingredient') {
                                        id = list.requestNum
                                    }
                                    if (list.type === 'ShiftPattern' ) {
                                        value = list.requestNum
                                    }
                                    return { label: text, value: value.toString(), id: id };
                                })
                            }
                            if (keyword.includes('/')) {
                                const arr = keyword.split('/')
                                keyword = arr[0]
                            }
                            localStorage.setItem('DropDownValues-' + keyword, JSON.stringify(data));
                            dispatch(keywordListSuccess(keyword, data));
                        }
                    })
                    .catch(err => {
                        dispatch(keywordListFail(err && err.response && err.response.data || 'Keyword List Api Error'));
                    })
            }
        }
        else {
            dispatch(keywordListSuccess(keyword, JSON.parse(masterTableList)));
        }
    }
}

export const getMasterCommonList = (keyword) => {
    return dispatch => {
        dispatch(keywordListStart());
        const masterTableList = localStorage.getItem('Common-' + keyword);
        if (!masterTableList) {
            axios.get('/master/api/' + keyword)
                .then(response => {
                    if (response.status === 200) {
                        localStorage.setItem('Common-' + keyword, JSON.stringify(response.data));
                        dispatch(keywordListSuccess(keyword, response.data));
                    }
                })
                .catch(err => {
                    dispatch(keywordListFail(err && err.response && err.response.data || 'List Api Error'));
                })
        }
        else {
            dispatch(keywordListSuccess(keyword, JSON.parse(masterTableList)));
        }
    }
}
